export const getNodeStyle = (
  nodeData: { type?: string; status?: string } | undefined
): React.CSSProperties => {
  const { type, status } = nodeData || {};

  if (status === "ACTIVE") {
    return { borderLeft: "6px solid #4caf50" };
  }
  if (status === "DRAFT") {
    return { borderLeft: "6px solid #bdbdbd" };
  }

  switch (type) {
    default:
      return { borderLeft: "6px solid #2196f3" };
  }
};
